import React from "react";

interface LoadingSpinnerProps {
  size?: "small" | "medium";
  position?: "before" | "after";
  className?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = "small",
  position = "after",
  className = ""
}) => {
  const sizeClass = size === "small" ? "filter-loading-spinner--small" : "";
  const positionClass = position === "before" ? "filter-loading-spinner--before" : "filter-loading-spinner--after";

  return (
    <i
      className={`fa fa-spinner fa-spin filter-loading-spinner ${sizeClass} ${positionClass} ${className}`}
      aria-label="Loading"
    />
  );
};

export default LoadingSpinner;
